import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b86115e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"padding-top":"65px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout, { style: {"margin":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                layout: "inline",
                model: _ctx.param
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: _ctx.param.name,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.param.name) = $event)),
                        placeholder: "名称",
                        allowClear: true
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_cascader, {
                        value: _ctx.param.categoryIds,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.param.categoryIds) = $event)),
                        "field-names": { label: 'name', value: 'id', children: 'children' },
                        options: _ctx.level1,
                        "change-on-select": "",
                        placeholder: "请选择分类",
                        style: {"width":"200px"}
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _ctx.resetQuery,
                        style: {"background":"#E6A23C"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 重置 ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleQuery({ page: 1, size: _ctx.pagination.pageSize })))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 查询 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.add()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 新增 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, { style: { background: '#fff', padding: '24px', margin: 0, minHeight: '280px' } }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                columns: _ctx.columns,
                "data-source": _ctx.ebooks,
                pagination: _ctx.pagination,
                loading: _ctx.loading,
                onChange: _ctx.handleTableChange
              }, {
                coverUrl: _withCtx(({ text: coverUrl }) => [
                  coverUrl
                    ? (_openBlock(), _createBlock(_component_a_image, {
                        key: 0,
                        width: 52,
                        preview: true,
                        src: coverUrl,
                        alt: "avatar"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true)
                ]),
                category: _withCtx(({ record }) => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.getCategoryName(record.category1Id)) + " / " + _toDisplayString(_ctx.getCategoryName(record.category2Id)), 1)
                ]),
                status: _withCtx(({ record }) => [
                  (record.status == 0)
                    ? (_openBlock(), _createBlock(_component_a_tag, {
                        key: 0,
                        color: "orange"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("未发布")
                        ]),
                        _: 1
                      }))
                    : (record.status == 1)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: "green"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("已发布")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                ]),
                action: _withCtx(({ record }) => [
                  _createVNode(_component_a_space, { size: "small" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, {
                        to: '/doc?ebookId=' + record.id,
                        slots: "a",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, { type: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 详情 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_router_link, {
                        to: '/admin/doc?ebookId=' + record.id,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, { type: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 文档管理 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: ($event: any) => (_ctx.edit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 编辑 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_a_popconfirm, {
                        title: "确认执行操作?",
                        "ok-text": "是",
                        "cancel-text": "否",
                        onConfirm: ($event: any) => (_ctx.publish(record))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: record.status == 1,
                            ghost: ""
                          }, {
                            default: _withCtx(() => [
                              (record.status == 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_1, "发布"))
                                : (record.status == 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "撤销"))
                                  : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["danger"])
                        ]),
                        _: 2
                      }, 1032, ["onConfirm"]),
                      _createVNode(_component_a_popconfirm, {
                        title: "删除后不可恢复，确认删除?",
                        "ok-text": "是",
                        "cancel-text": "否",
                        onConfirm: ($event: any) => (_ctx.handleDelete(record.id))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 删除 ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onConfirm"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              }, 8, ["columns", "data-source", "pagination", "loading", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_modal, {
        title: "电子书表单",
        open: _ctx.modalVisible,
        "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalVisible) = $event)),
        "confirm-loading": _ctx.modalLoading,
        onOk: _ctx.handleModalOk
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            model: _ctx.ebook,
            "label-col": { span: 6 },
            "wrapper-col": { span: 18 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "封面" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.ebook.cover,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ebook.cover) = $event)),
                    disabled: true,
                    allowClear: true
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_upload, {
                    "file-list": _ctx.fileList,
                    "onUpdate:fileList": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fileList) = $event)),
                    name: "file",
                    "list-type": "picture-card",
                    class: "avatar-uploader",
                    "show-upload-list": false,
                    action: _ctx.SERVER + '/file/upload/avatar',
                    "before-upload": _ctx.beforeUpload,
                    headers: _ctx.uploadHeaders,
                    onChange: _ctx.handleChange
                  }, {
                    default: _withCtx(() => [
                      (_ctx.imageUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.imageUrl,
                            alt: "avatar"
                          }, null, 8, _hoisted_3))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_ctx.coverLoading)
                              ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                            _hoisted_5
                          ]))
                    ]),
                    _: 1
                  }, 8, ["file-list", "action", "before-upload", "headers", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.ebook.name,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ebook.name) = $event)),
                    allowClear: true
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "分类" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_cascader, {
                    value: _ctx.categoryIds,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.categoryIds) = $event)),
                    "field-names": { label: 'name', value: 'id', children: 'children' },
                    options: _ctx.level1
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "描述" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.ebook.description,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ebook.description) = $event)),
                    type: "textarea",
                    allowClear: true
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["open", "confirm-loading", "onOk"]),
      _createVNode(_component_TheFooter)
    ]),
    _: 1
  }))
}